import _, {filter, includes, orderBy, isEmpty, union} from 'lodash'

const unsignedStatus = ['NO FIRMADO', 'RECHAZADO', 'PENDIENTE APROBACION']

const getters = {
  getUnsignedDocs({ documents }) {
    const unsignedDocs = filter(documents, document => {
      if (document.firmado === 'NO FIRMADO') {
        document['status'] = document.bloquear ? 'bloqued' : 'active'
        document['locked'] = document.bloquear
        return document
      }
    })

    return orderBy(
      unsignedDocs,
      ['bloquear', doc => parseInt(doc.id, 10)],
      ['asc', 'asc']
    )
  },
  getSignedDocs({ documents, efimeroFoldersIds }) {
    const signedDocs = filter(documents, document => {
      if (
        !includes(efimeroFoldersIds, document.carpeta_id) &&
        !includes(unsignedStatus, document.firmado)
      ) {
        return document
      }
    })

    return orderBy(signedDocs, [doc => parseInt(doc.id, 10)], ['desc'])
  },

  getUnsignedDocsInbox({ unsigned }) {
    return unsigned
  },

  getSignedDocsInbox({ signed }) {
    return signed
  },

  getUnsignedTotalDocsLength({ documentsTotalUnsigned }) {
    return documentsTotalUnsigned
  },

  foldersName({ signed, unsigned, documents }) {
    let collectionDocs = _.union(signed, unsigned)
    if (!isEmpty(documents))  collectionDocs = documents
    return _.chain(collectionDocs)
      .reduce((acc, document) => {
        acc.push(document.carpeta_nombre)
        return acc
      }, [])
      .uniqBy()
      .value()
  }
}

export default getters
